import React, { useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { X } from 'lucide-react';
export function Footer() {
  const [showTerms, setShowTerms] = useState(false);
  return <>
      <footer className="py-12 px-6 bg-bg-main border-t border-white/5 text-center" data-id="element-10">
        <p className="font-serif text-2xl text-text-primary mb-4" data-id="element-11">
          Anti-Impulso
        </p>
        <p className="text-text-muted text-sm mb-6" data-id="element-12">
          © {new Date().getFullYear()} Todos los derechos reservados.
        </p>
        <button onClick={() => setShowTerms(true)} className="text-text-secondary text-xs underline underline-offset-4 decoration-text-muted/30 hover:text-brand-gold hover:decoration-brand-gold/40 transition-colors duration-300" data-id="element-13">
          Términos y Condiciones
        </button>
      </footer>

      {/* Terms & Conditions Modal */}
      <AnimatePresence data-id="element-14">
        {showTerms && <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} exit={{
        opacity: 0
      }} transition={{
        duration: 0.25
      }} className="fixed inset-0 z-50 flex items-center justify-center p-4 md:p-8" onClick={() => setShowTerms(false)} data-id="element-15">
            {/* Backdrop */}
            <div className="absolute inset-0 bg-black/70 backdrop-blur-sm" data-id="element-16" />

            {/* Modal */}
            <motion.div initial={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} animate={{
          opacity: 1,
          scale: 1,
          y: 0
        }} exit={{
          opacity: 0,
          scale: 0.95,
          y: 20
        }} transition={{
          duration: 0.3,
          ease: 'easeOut'
        }} onClick={e => e.stopPropagation()} className="relative w-full max-w-2xl max-h-[80vh] bg-bg-secondary border border-white/10 rounded-2xl shadow-2xl overflow-hidden" data-id="element-17">
              {/* Header */}
              <div className="sticky top-0 z-10 flex items-center justify-between px-8 py-5 bg-bg-secondary/95 backdrop-blur-md border-b border-white/5" data-id="element-18">
                <h2 className="font-serif text-xl text-text-primary" data-id="element-19">
                  Términos y Condiciones
                </h2>
                <button onClick={() => setShowTerms(false)} className="w-8 h-8 flex items-center justify-center rounded-full text-text-muted hover:text-text-primary hover:bg-white/5 transition-colors" data-id="element-20">
                  <X className="w-5 h-5" data-id="element-21" />
                </button>
              </div>

              {/* Content */}
              <div className="px-8 py-6 overflow-y-auto max-h-[calc(80vh-72px)] text-sm text-text-secondary leading-relaxed space-y-6" data-id="element-22">
                <p className="text-text-muted text-xs" data-id="element-23">
                  Última actualización:{' '}
                  {new Date().toLocaleDateString('es-CO', {
                year: 'numeric',
                month: 'long',
                day: 'numeric'
              })}
                </p>

                <div className="space-y-4" data-id="element-24">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-25">
                    1. Generalidades
                  </h3>
                  <p data-id="element-26">
                    Al adquirir el workbook "Anti-Impulso: Cierra el Mes",
                    aceptas los presentes términos y condiciones. Este producto
                    es un recurso digital educativo diseñado para uso personal.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-27">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-28">
                    2. Producto Digital
                  </h3>
                  <p data-id="element-29">
                    El workbook se entrega en formato digital (PDF y plantillas
                    compatibles con Google Sheets/Notion). Una vez realizada la
                    compra, recibirás acceso inmediato al material a través del
                    correo electrónico proporcionado.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-30">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-31">
                    3. Uso Personal
                  </h3>
                  <p data-id="element-32">
                    El contenido del workbook es para uso exclusivamente
                    personal. Queda prohibida su reproducción, distribución,
                    reventa o compartición total o parcial sin autorización
                    expresa por escrito.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-33">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-34">
                    4. Política de Reembolso
                  </h3>
                  <p data-id="element-35">
                    Debido a la naturaleza digital del producto, ofrecemos una
                    garantía de satisfacción. Si no estás conforme con el
                    contenido, puedes solicitar un reembolso dentro de los
                    primeros 7 días calendario posteriores a la compra, siempre
                    que no se haya descargado o utilizado más del 20% del
                    material.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-36">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-37">
                    5. Propiedad Intelectual
                  </h3>
                  <p data-id="element-38">
                    Todo el contenido del workbook, incluyendo textos, diseños,
                    plantillas y metodologías, es propiedad intelectual de
                    Anti-Impulso. Está protegido por las leyes de derechos de
                    autor aplicables.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-39">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-40">
                    6. Limitación de Responsabilidad
                  </h3>
                  <p data-id="element-41">
                    Este workbook es una herramienta educativa y de autogestión.
                    No constituye asesoría financiera profesional. Los
                    resultados pueden variar según el compromiso y la situación
                    individual de cada usuario. No nos hacemos responsables por
                    decisiones financieras tomadas con base en el contenido del
                    workbook.
                  </p>
                </div>

                <div className="space-y-4" data-id="element-42">
                  <h3 className="text-text-primary font-medium text-base" data-id="element-43">
                    7. Modificaciones
                  </h3>
                  <p data-id="element-44">
                    Nos reservamos el derecho de modificar estos términos en
                    cualquier momento. Las modificaciones serán efectivas desde
                    su publicación. El uso continuado del producto implica la
                    aceptación de los términos actualizados.
                  </p>
                </div>

                <div className="pt-4 border-t border-white/5" data-id="element-45">
                  <p className="text-text-muted text-xs" data-id="element-46">
                    Al realizar tu compra, confirmas que has leído y aceptado
                    estos términos y condiciones en su totalidad.
                  </p>
                </div>
              </div>
            </motion.div>
          </motion.div>}
      </AnimatePresence>
    </>;
}